import strings from '../../Localization/Localization';

import { checkCode } from '../../API/Products';

import { fetchFamilies } from '../../API/ProductFamilies';

import { fetchSubFamilies } from '../../API/ProductSubFamilies';
import { fetchConstructors } from '../../API/Constructors';
import { fetchDocuments } from '../../API/Documents';
import { fetchAlphalinkMobileProducts } from '../../API/AlphalinkMobileProducts';
import { fetchTransatelMobileProducts } from '../../API/TransatelMobileProducts';

import { form as _buyingPriceForm } from './buyingPrice';
import { newDefaultContractForm as _newDefaultContractForm } from './contracts'
import { productDependencySlaveForm as _productSlaveForm } from './productDependencies';
import { productDependencyMasterForm as _productMasterForm } from './productDependencies';
import { form as _phonePackageProductForm } from './phonePackageProducts';
import { form as _productCreditPackForm } from './productCreditPacks';

import {
  documents as documentsRoutes
} from '../Route/routes';

import FormFieldPrice from '../../Component/Form/Field/FormFieldPrice';

let name = {
  fieldKey: "name",
  type: "text",
  label: strings.form.product.name.label,
  validators: [
    {
      id: 'assertEmpty',
      type: 'lengthMin',
      conf: {
        min: 1
      },
      invalidFeedback: strings.form.product.name.invalid.assertEmpty,
      defaultValue: false
    },
    {
      id: 'assertMax',
      type: 'lengthMax',
      conf: {
        max: 100
      },
      invalidFeedback: strings.form.product.name.invalid.assertMax,
      defaultValue: false
    },
  ]
}

let code = {
  fieldKey: "code",
  type: "text",
  label: strings.form.product.code.label,
  validators: [
    {
      id: 'assertEmpty',
      type: 'lengthMin',
      conf: {
        min: 1
      },
      invalidFeedback: strings.form.product.code.invalid.assertEmpty,
      defaultValue: false
    },
    {
      id: 'assertMax',
      type: 'lengthMax',
      conf: {
        max: 40
      },
      invalidFeedback: strings.form.product.code.invalid.assertMax,
      defaultValue: false
    },
    {
      id: 'assertUnique',
      type: 'call',
      call: (value, getValues) => checkCode(getValues()["id"], value),
      invalidFeedback: strings.form.product.code.invalid.assertUnique,
      defaultValue: true,
    }
  ]
}

let description = {
  fieldKey: "description",
  type: "textarea",
  label: strings.form.product.description.label,
  validators: [
    {
      id: 'assertMax',
      type: 'lengthMax',
      conf: {
        max: 1024
      },
      invalidFeedback: strings.form.product.description.invalid.assertMax,
      defaultValue: false
    },
  ]
}

let productFamily = {
  fieldKey: "product_family",
  label: strings.form.product.productFamily.label,
  type: "dropdownEntity",

  validators: [
    {
      id: 'assertEmpty',
      type: 'notEmptyOrNull',
      invalidFeedback: strings.form.product.productFamily.invalid.assertEmpty,
      defaultValue: false
    },
  ],

  showEmpty: true,
  loader: {
    id: "productFamilies",
    loader: fetchFamilies,
    loaderRequire: () => true,
    loaderArguments: () => [],
  },

  adapter: {
    requirement: (data) => typeof data === 'object' && data["id"] && data["name"],
    getValue: (data) => data["id"],
    getLabel: (data) => data["name"],
  },
}

let productSubFamily = {
  fieldKey: "product_sub_family",
  label: strings.form.product.productSubFamily.label,
  type: "dropdownEntity",

  validators: [
    {
      id: 'assertEmpty',
      type: 'notEmptyOrNull',
      invalidFeedback: strings.form.product.productSubFamily.invalid.assertEmpty,
      defaultValue: false
    },
  ],

  events: [
    {
      id: "reload",
      event: "onChange",
      target: "product_family",
      function: (component) => component.reloadData()
    }
  ],

  showEmpty: true,
  loader: {
    id: "productSubFamilies",
    loader: fetchSubFamilies,
    loaderRequire: (value, getValues) => getValues(0)["product_family"] && getValues(0)["product_family"]["id"],
    loaderArguments: (value, getValues) => {
      return [{
        product_family_id: getValues(0)["product_family"]["id"]
      }]
    },
  },

  adapter: {
    requirement: (data) => typeof data === 'object' && data["id"] && data["name"],
    getValue: (data) => data["id"],
    getLabel: (data) => data["name"],
  },
}

let constructor = {
  fieldKey: "constructor",
  label: strings.form.product.constructor.label,
  type: "dropdownEntity",

  validators: [],

  showEmpty: true,
  loader: {
    id: "constructors",
    loader: fetchConstructors,
    loaderRequire: () => true,
    loaderArguments: () => [],
  },

  adapter: {
    requirement: (data) => typeof data === 'object' && data["id"] && data["name"],
    getValue: (data) => data["id"],
    getLabel: (data) => data["name"],
  },
}

let constructorReference = {
  fieldKey: "constructor_reference",
  type: "text",
  label: strings.form.product.constructorReference.label,
  validators: [
    {
      id: 'assertMax',
      type: 'lengthMax',
      conf: {
        max: 30
      },
      invalidFeedback: strings.form.product.constructorReference.invalid.assertMax,
      defaultValue: true
    }
  ]
}

let constructorLink = {
  fieldKey: "constructor_link",
  type: "text",
  label: strings.form.product.constructorLink.label,

  disabledLink: (value) => value?value:'#',

  validators: [
    {
      id: 'assertMax',
      type: 'lengthMax',
      conf: {
        max: 255
      },
      invalidFeedback: strings.form.product.constructorLink.invalid.assertMax,
      defaultValue: true
    }
  ]
}

let img = {
  fieldKey: "img",
  type: "file",
  label: strings.form.product.img.label,
  showOnDisabled: () => false,

  validators: [],
}

let activeOrder = {
  fieldKey: "active_order",
  type: "switch",
  label: strings.form.product.activeOrder.label,
  defaultValue: null,
  validators: []
}

let activeQuote = {
  fieldKey: "active_quote",
  type: "switch",
  label: strings.form.product.activeQuote.label,
  defaultValue: null,
  validators: []
}

let activeTicket = {
  fieldKey: "active_ticket",
  type: "switch",
  label: strings.form.product.activeTicket.label,
  defaultValue: null,
  validators: []
}

let orderBreaking = {
  fieldKey: "order_breaking",
  type: "triswitch",
  label: strings.form.product.orderBreaking.label,
  defaultValue: null,
  validators: []
}

let serviceTracking = {
  fieldKey: "service_tracking",
  type: "triswitch",
  label: strings.form.product.serviceTracking.label,
  defaultValue: null,
  validators: []
}

let serviceBreaking = {
  fieldKey: "service_breaking",
  type: "triswitch",
  label: strings.form.product.serviceBreaking.label,
  defaultValue: null,
  validators: []
}

let rentable = {
  fieldKey: "rentable",
  type: "triswitch",
  label: strings.form.product.rentable.label,
  defaultValue: null,
  validators: []
}

let displayMainIndex = {
  fieldKey: "display_main_index",
  type: "triswitch",
  label: strings.form.productSubFamily.displayMainIndex.label,
  defaultValue: null,
  validators: []
}

let price = {
  fieldKey: "price",
  type: "price",
  label: strings.form.product.price.label,
  validators: []
}

let priceType = {
  fieldKey: "price_type",
  type: "dropdown",
  label: strings.form.product.priceType.label,
  validators: [],

  showEmpty: true,
  input: 'options',
  options: [
    {
      value: 0,
      label: strings.form.product.priceType.options.option0
    },
    {
      value: 1,
      label: strings.form.product.priceType.options.option1
    },
    {
      value: 2,
      label: strings.form.product.priceType.options.option2
    }
  ],
}

let minPrice = {
  fieldKey: "min_price",
  type: "price",
  label: strings.form.product.minPrice.label,
  validators: [
    // {
    //   id: 'assertEmpty',
    //   type: 'notEmptyOrNull',
    //   invalidFeedback: strings.form.product.minPrice.invalid.assertEmpty,
    //   defaultValue: false
    // },
    {
      id: 'assertMax',
      type: 'function',
      invalidFeedback: strings.form.product.minPrice.invalid.assertMax,
      defaultValue: false,

      conf: {
        function: (value, getValues) => {
          let ownValue = value;
          let priceValue = getValues()['price'];
          if(priceValue || priceValue === 0 || priceValue === '0') {
            if(isNaN(ownValue)) {
              ownValue = FormFieldPrice.parseFinalValue(ownValue);
            }
            if(isNaN(priceValue)) {
              priceValue = FormFieldPrice.parseFinalValue(priceValue);
            }
            if(Number(priceValue) >= Number(ownValue)) {
              return true;
            }
          }
          return false;
        }
      }
    },
  ]
}

let commercialBonusPercentage = {
  fieldKey: "commercial_bonus_percentage",
  type: "text",
  label: strings.form.product.commercialBonusPercentage.label,
  validators: [],

  messageRight: "%"
}

let commercialBonusPercentageNoDiscount = {
  fieldKey: "commercial_bonus_percentage_no_discount",
  type: "text",
  label: strings.form.product.commercialBonusPercentageNoDiscount.label,
  validators: [],

  messageRight: "%"
}

let buyingPrices = {
  fieldKey: "buying_prices",
  type: "array",
  label: strings.form.product.buyingPrices.label,

  defaultNumberOfField: 0,
  allowMoreField: true,

  allowMoreFieldAddLabel: strings.form.product.buyingPrices.allowMoreField.addLabel,
  allowMoreFieldRemoveLabel: strings.form.product.buyingPrices.allowMoreField.removeLabel,
  allowMoreFieldRemovingLabel: strings.form.product.buyingPrices.allowMoreField.removingLabel,

  subField: {
    type: "subform",
    label: "",

    subForm: _buyingPriceForm,

    validators: [],
  },

  validators: []
}

let contract = {
  fieldKey: "contract",
  type: "subform",
  label: "",

  subForm: _newDefaultContractForm,

  validators: []
}

let productMasters = {
  fieldKey: "product_masters",
  type: "array",
  label: strings.form.product.productMasters.label,
  disabled: true,

  defaultNumberOfField: 0,
  allowMoreField: true,

  allowMoreFieldAddLabel: strings.form.product.productMasters.allowMoreField.addLabel,
  allowMoreFieldRemoveLabel: strings.form.product.productMasters.allowMoreField.removeLabel,
  allowMoreFieldRemovingLabel: strings.form.product.productMasters.allowMoreField.removingLabel,

  subField: {
    type: "subform",
    label: "",

    subForm: _productMasterForm,

    validators: [],
  },

  validators: []
}

let productSlaves = {
  fieldKey: "product_slaves",
  type: "array",
  label: strings.form.product.productSlaves.label,
  disabled: true,

  defaultNumberOfField: 0,
  allowMoreField: true,

  allowMoreFieldAddLabel: strings.form.product.productSlaves.allowMoreField.addLabel,
  allowMoreFieldRemoveLabel: strings.form.product.productSlaves.allowMoreField.removeLabel,
  allowMoreFieldRemovingLabel: strings.form.product.productSlaves.allowMoreField.removingLabel,

  subField: {
    type: "subform",
    label: "",

    subForm: _productSlaveForm,

    validators: [],
  },

  validators: []
}

let specificConditionsOfSale = {
  fieldKey: "specific_conditions_of_sale",
  label: strings.form.productSubFamily.specificConditionsOfSale.label,
  type: "dropdownEntity",

  disabledLink: (value) => value?documentsRoutes.routes.show.createPath(value["id"]):'#',

  validators: [],

  showEmpty: true,
  assertObjectDefaultValue: true,
  loader: {
    id: "specificConditionsOfSale",
    loader: fetchDocuments,
    loaderRequire: () => true,
    loaderArguments: () => {
      return [{
        doc_type: 'stc'
      }]
    },
  },

  adapter: {
    requirement: (data) => typeof data === 'object' && data["id"] && data["name"],
    getValue: (data) => data["id"],
    getLabel: (data) => data["name"],
  },
}

let datasheet = {
  fieldKey: "datasheet_values",
  type: "array",
  label: "",

  validators: [],

  allowMoreField: false,
  defaultNumberOfField: 0,

  subField: {
    type: 'configurableField',
    label: "",
    validators: [],

    subField: () => {},
    subFieldConf: {
      label: (value) => value["datasheet"]["name"],
      type: (value) => 'text',
      disabled: () => false,
      validators: (value) => [],
      valueAttribute: 'value'
    },
  }
}

let phonePackageProduct = {
  fieldKey: "phone_package",
  type: "subform",
  label: strings.form.product.phonePackage.label,

  subForm: _phonePackageProductForm,

  validators: [],
}

let alphalinkMobileProduct = {
  fieldKey: "alphalink_mobile_products",
  label: "",
  type: "array",

  validators: [],

  defaultNumberOfField: 0,
  allowMoreField: true,

  allowMoreFieldAddLabel: strings.form.product.alphalinkMobileProduct.allowMoreField.addLabel,
  allowMoreFieldRemoveLabel: strings.form.product.alphalinkMobileProduct.allowMoreField.removeLabel,
  allowMoreFieldRemovingLabel: strings.form.product.alphalinkMobileProduct.allowMoreField.removingLabel,

  subField: {
    type: "dropdownEntity",
    label: strings.form.product.alphalinkMobileProduct.label,

    validators: [],

    showEmpty: true,
    loader: {
      id: "alphalinkMobileProducts",
      loader: fetchAlphalinkMobileProducts,
      loaderRequire: () => true,
      loaderArguments: () => [],
    },

    adapter: {
      requirement: (data) => typeof data === 'object' && data["id"] && data["name"],
      getValue: (data) => data["id"],
      getLabel: (data) => data["name"],
    },
  },
}

let transatelMobileProduct = {
  fieldKey: "transatel_mobile_products",
  label: "",
  type: "array",

  validators: [],

  defaultNumberOfField: 0,
  allowMoreField: true,

  allowMoreFieldAddLabel: strings.form.product.transatelMobileProduct.allowMoreField.addLabel,
  allowMoreFieldRemoveLabel: strings.form.product.transatelMobileProduct.allowMoreField.removeLabel,
  allowMoreFieldRemovingLabel: strings.form.product.transatelMobileProduct.allowMoreField.removingLabel,

  subField: {
    type: "dropdownEntity",
    label: strings.form.product.transatelMobileProduct.label,

    validators: [],

    showEmpty: true,
    loader: {
      id: "transatelMobileProducts",
      loader: fetchTransatelMobileProducts,
      loaderRequire: () => true,
      loaderArguments: () => [],
    },

    adapter: {
      requirement: (data) => typeof data === 'object' && data["id"] && data["name"],
      getValue: (data) => data["id"],
      getLabel: (data) => data["name"],
    },
  },
}

let productCreditPack = {
  fieldKey: "product_credit_pack",
  type: "subform",
  label: strings.form.product.productCreditPack.label,

  subForm: _productCreditPackForm,

  validators: [],
}

export const mvnoProductForm = {
  formKey: "product",
  fields: [
    alphalinkMobileProduct,
    transatelMobileProduct
  ]
}

export const datasheetForm = {
  formKey: "product",
  fields: [
    datasheet
  ]
}

export const priceForm = {
  formKey: "product",
  fields: [
    price,
    priceType,
    minPrice,
    commercialBonusPercentage,
    commercialBonusPercentageNoDiscount,
    buyingPrices
  ]
}

export const dependencyForm = {
  formKey: "product",
  fields: [
    productMasters,
    productSlaves
  ]
}

export const configurationForm = {
  formKey: "product",
  fields: [
    activeOrder,
    activeQuote,
    activeTicket,
    orderBreaking,
    serviceTracking,
    serviceBreaking,
    rentable,
    displayMainIndex
  ]
}

export const configurationEditForm = {
  formKey: "product",
  fields: [
    activeOrder,
    activeQuote,
    activeTicket,
    orderBreaking,
    serviceTracking,
    serviceBreaking,
    rentable,
    displayMainIndex
  ]
}

export const contractForm = {
  formKey: "product",
  fields: [
    contract
  ]
}

export const specificConditionsOfSaleForm = {
  formKey: "product",
  fields: [
    specificConditionsOfSale
  ]
}

export const phonePackageForm = {
  formKey: "product",
  fields: [
    phonePackageProduct
  ]
}

export const creditPackForm = {
  formKey: "product",
  fields: [
    productCreditPack
  ]
}

export const form = {
  formKey: "product",
  fields: [
    name,
    code,
    description,
    img,
    productFamily,
    productSubFamily,
    constructor,
    constructorReference,
    constructorLink
  ]
}

export const newForm = {
  formKey: "product",
  fields: [
    name,
    code,
    description,
    img,
    productFamily,
    productSubFamily,
    activeOrder,
    activeQuote,
    activeTicket,
    orderBreaking,
    serviceTracking,
    serviceBreaking,
    rentable,
    price,
    priceType,
    minPrice,
    commercialBonusPercentage,
    commercialBonusPercentageNoDiscount,
    buyingPrices,
    contract,
    // productMasters,
    // productSlaves,
    specificConditionsOfSale,
    constructor,
    constructorReference,
    constructorLink
  ]
}
